import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'first_login';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/FirstLogin')));